import { BASE_API_URL } from '@/constants';
import { apiPath } from '@/redux/apiPath';
import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { openEditOverlayModal } from '@/redux/modal/modal.slice';
import { MapOverlay } from '@/types/models';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { projectDataSelector } from '@/redux/project/project.selectors';
import { showToast } from '@/utils/showToast';
import { ACTION_TYPES } from '../UserOverlayActions.constants';

type UseUserOverlayActionsReturn = {
  handleActionClick: (action: string) => void;
};

export const useUserOverlayActions = (overlay: MapOverlay): UseUserOverlayActionsReturn => {
  const dispatch = useAppDispatch();
  const project = useAppSelector(projectDataSelector);

  const handleDownloadOverlay = (): void => {
    window.open(`${BASE_API_URL}/${apiPath.downloadOverlay(overlay.id)}`, '_blank');
  };

  const handleEditOverlay = (): void => {
    if (project?.readonly) {
      showToast({
        type: 'error',
        message: 'You are not allowed to edit overlays in this project',
      });
    } else {
      dispatch(openEditOverlayModal(overlay));
    }
  };

  const handleActionClick = (action: string): void => {
    switch (action) {
      case ACTION_TYPES.DOWNLOAD:
        handleDownloadOverlay();
        break;
      case ACTION_TYPES.EDIT:
        handleEditOverlay();
        break;
      default:
        throw new Error(`${action} is not valid`);
    }
  };

  return {
    handleActionClick,
  };
};
